module.exports = __webpack_public_path__ + "static/media/vscode.6efd8d77.png";